export default {
  title: '粉丝关系',
  body: {
    cmpt: {
      type: 'CUserList'
    }
  }
}
